import { Form } from "src/app/models/form.model";
import {
  Component,
  ViewChild,
  TemplateRef,
  Input,
  ChangeDetectorRef,
} from "@angular/core";
import { PropiedadService } from "../../../services/propiedad.service";
import { Propiedad } from "../../../models/propiedad.model";
import { MatDialog, MatSelect } from "@angular/material";
import { FormService } from "src/app/services/form.service";
import { FormControl, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import * as FormActions from "../../../reducers/actions/forms.actions";
import { Store } from "@ngrx/store";
import { Router } from "@angular/router";
import { ReplaySubject, Subject, Observable } from "rxjs";
import { take, takeUntil, map, startWith } from "rxjs/operators";

declare var jQuery: any;
declare var $: any;
declare const swal: any;
interface AppState {
  form: Form;
}
@Component({
  selector: "page-propiedad",
  templateUrl: "./propiedad.component.html",
  providers: [PropiedadService, FormService],
})
export class PropiedadComponent {
  @ViewChild("openModal") openModal: TemplateRef<any>;
  @ViewChild("openModalNOROL") openModalNOROL: TemplateRef<any>;
  @ViewChild("modalDirecciones") modalDirecciones: TemplateRef<any>;
  @ViewChild("openModalVerPorRol") openModalVerPorRol: TemplateRef<any>;
  @ViewChild("singleSelect") singleSelect: MatSelect;

  public invalidRol: Boolean;
  public propiedad: Propiedad;
  public rows = [];
  public actualRow;
  public direcciones = [];
  public p: number = 1;
  public searchText;
  public temp_dir;
  public isopen = false;
  public rol = new FormControl("", [Validators.required]);
  public dir = new FormControl("", [Validators.required]);
  public num = new FormControl("", [Validators.required]);
  public calles = [];
  public filteredCalles: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public buscarCalle: FormControl = new FormControl();
  protected _onDestroy = new Subject<void>();
  myControl = new FormControl();
  options = [];
  filteredOptions: Observable<string[]>;

  //bandera
  rol_dir_encontrada = false;

  matcher = new FormService();

  public numForm = 0;
  public formulario = "";

  constructor(
    private _PropiedadService: PropiedadService,
    private _router: Router,
    private store: Store<AppState>,
    public dialog: MatDialog,
    public _formService: FormService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef
  ) {
    this.formulario = localStorage.getItem("form");
    


    if (!JSON.parse(localStorage.getItem("informacionPropiedad"))) {
      localStorage.setItem("informacionPropiedad", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("informacionPropiedad"));
    }
    this.invalidRol = true;
    this.propiedad = {
      rol: "",
      id_direcc: "",
      folio: "",
      calle: "",
      calle_num: 0,
      direccion_completa: "",
      direc_complemento: "",
      direc_compl_num: "",
      loteo: "",
      manzana: "",
      plano: "",
      ubicacion: "",
      recordId: "",
      localidad: "",
      json: {},
    };
  }

  intervalId: any;

  ngOnInit() {
    this.traerCalles();
    this.filteredOptions = this.dir.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value))
    );
    // Cargar los datos iniciales
    this.loadFromLocalStorage();

    // Revisar periódicamente cambios en el localStorage
    this.intervalId = setInterval(() => {
      this.loadFromLocalStorage();
    }, 1000); // Revisa cada segundo
  }

  ngOnDestroy() {
    // Limpiar el intervalo cuando el componente se destruye
    clearInterval(this.intervalId);
  }

  loadFromLocalStorage() {
    const storedData = JSON.parse(localStorage.getItem("informacionPropiedad"));
    if (storedData && storedData.length > 0) {
      this.rows = storedData;
      this.cdr.detectChanges();
    }
  }

  private _filter(value: string): string[] {
    if (value != null) {
      const filterValue = value.toLowerCase();
      return this.options.filter((option) =>
        option.toLowerCase().includes(filterValue)
      );
    }
  }
  getPropiedad_rol() {
    this.spinner.show();
    this._PropiedadService
      .getPropiedadESRI(this.rol.value, undefined, undefined, undefined)
      .subscribe(
        (response) => {
          console.log("probando que viene", response);
          if (response.status == "error") {
            this.spinner.hide();
            swal({
              type: "warning",
              title: "Ha ocurrido un problema!",
              text: response.message,
              confirmButtonColor: "#3F51B5",
              confirmButtonText: "Aceptar",
              timer: 3500,
              onClose: () => {},
            }).then(
              () => {},
              (dismiss) => {}
            );
          } else {
            if (response.direcciones) {
              this.direcciones = response.direcciones;
              this.dialog.open(this.modalDirecciones);
              this.spinner.hide();
            } else {
              if (response.message) {
                this.propiedad.rol = this.rol.value ? this.rol.value : "";
                this.rol_dir_encontrada = false;
                this.spinner.hide();
                this.dialog.open(this.openModalNOROL);
              } else {
                this.propiedad.rol = response.rol ? response.rol : "";
                this.propiedad.id_direcc = response.id_direcc
                  ? response.id_direcc
                  : "";
                this.propiedad.folio = response.folio ? response.folio : "";
                this.propiedad.calle = response.calle ? response.calle : "";
                this.propiedad.calle_num = response.calle_num
                  ? response.calle_num === "0"
                    ? ""
                    : response.calle_num
                  : "";
                this.propiedad.direccion_completa = response.direccion_completa
                  ? response.direccion_completa
                  : "";
                this.propiedad.direc_complemento = response.direc_complemento
                  ? response.direc_complemento
                  : "";
                this.propiedad.direc_compl_num = response.direc_compl_num
                  ? response.direc_compl_num
                  : "";
                this.propiedad.loteo = response.loteo ? response.loteo : "";
                this.propiedad.manzana = response.manzana
                  ? response.manzana
                  : "";
                this.propiedad.plano = response.plano ? response.plano : "";
                this.propiedad.ubicacion = response.ubicacion
                  ? response.ubicacion
                  : "";
                this.propiedad.recordId = response.recordId
                  ? response.recordId
                  : "";
                this.propiedad.localidad = response.localidad
                  ? response.localidad
                  : "";
                this.propiedad.json = response.json ? response.json : {};

                this.rol_dir_encontrada = true;

                this.dialog.open(this.openModal);
                this.spinner.hide();
              }
            }
          }
        },
        (error) => {
          let e = JSON.parse(error._body);
          alert(e.message);
          console.log(error);
          this.spinner.hide();
        }
      );
  }

  getPropiedad_por_rol(rol, id) {
    //3900-32
    this.spinner.show();
    this._PropiedadService
      .getPropiedadESRI(rol, id, undefined, undefined)
      .subscribe(
        (response) => {
          console.log(response);
          if (response.status == "error") {
            this.spinner.hide();
            swal({
              type: "warning",
              title: "Ha ocurrido un problema!",
              text: response.message,
              confirmButtonColor: "#3F51B5",
              confirmButtonText: "Aceptar",
              timer: 3500,
              onClose: () => {},
            }).then(
              () => {},
              (dismiss) => {}
            );
          } else {
            if (response.direcciones) {
              this.direcciones = response.direcciones;
              this.dialog.open(this.modalDirecciones);
              this.spinner.hide();
            } else {
              if (response.message) {
                this.propiedad.rol = this.rol.value ? this.rol.value : "";
                this.rol_dir_encontrada = false;
                this.dialog.open(this.openModalVerPorRol);
                this.spinner.hide();
              } else {
                this.propiedad.rol = response.rol ? response.rol : "";
                this.propiedad.id_direcc = response.id_direcc
                  ? response.id_direcc
                  : "";
                this.propiedad.folio = response.folio ? response.folio : "";
                this.propiedad.calle = response.calle ? response.calle : "";
                this.propiedad.calle_num = response.calle_num
                  ? response.calle_num === "0"
                    ? ""
                    : response.calle_num
                  : "";
                this.propiedad.direccion_completa = response.direccion_completa
                  ? response.direccion_completa
                  : "";
                this.propiedad.direc_complemento = response.direc_complemento
                  ? response.direc_complemento
                  : "";
                this.propiedad.direc_compl_num = response.direc_compl_num
                  ? response.direc_compl_num
                  : "";
                this.propiedad.loteo = response.loteo ? response.loteo : "";
                this.propiedad.manzana = response.manzana
                  ? response.manzana
                  : "";
                this.propiedad.plano = response.plano ? response.plano : "";
                this.propiedad.ubicacion = response.ubicacion
                  ? response.ubicacion
                  : "";
                this.propiedad.recordId = response.recordId
                  ? response.recordId
                  : "";
                this.propiedad.localidad = response.localidad
                  ? response.localidad
                  : "";
                this.propiedad.json = response.json ? response.json : {};

                this.rol_dir_encontrada = true;

                this.dialog.open(this.openModalVerPorRol);
                this.spinner.hide();
              }
            }
          }
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }

  getPropiedad_dir() {
    this.spinner.show();
    this._PropiedadService
      .getPropiedadESRI(
        undefined,
        undefined,
        this.dir.value.trim(),
        this.num.value.trim()
      )
      .subscribe(
        (response) => {
          this.spinner.hide();

          if (response.status == "error") {
            this.spinner.hide();
            swal({
              type: "warning",
              title: "Ha ocurrido un problema!",
              text: response.message,
              confirmButtonColor: "#3F51B5",
              confirmButtonText: "Aceptar",
              timer: 3500,
              onClose: () => {},
            }).then(
              () => {},
              (dismiss) => {}
            );
          } else {
            if (response.message) {
              //this.propiedad.dir = dir ? dir : '';
              // this.propiedad.num = num ? num : '';
              this.propiedad.calle = this.dir.value ? this.dir.value : "";
              this.rol_dir_encontrada = false;
              this.propiedad.calle_num = this.num.value
                ? this.num.value === "0"
                  ? ""
                  : this.num.value
                : "";
              this.dialog.open(this.openModalNOROL);
            } else {
              this.propiedad.rol = response.rol ? response.rol : "";
              this.propiedad.id_direcc = response.id_direcc
                ? response.id_direcc
                : "";
              this.propiedad.folio = response.folio ? response.folio : "";
              this.propiedad.calle = response.calle ? response.calle : "";
              this.propiedad.calle_num = response.calle_num
                ? response.calle_num === "0"
                  ? ""
                  : response.calle_num
                : "";
              this.propiedad.direccion_completa = response.direccion_completa
                ? response.direccion_completa
                : "";
              this.propiedad.direc_complemento = response.direc_complemento
                ? response.direc_complemento
                : "";
              this.propiedad.direc_compl_num = response.direc_compl_num
                ? response.direc_compl_num
                : "";
              this.propiedad.loteo = response.loteo ? response.loteo : "";
              this.propiedad.manzana = response.manzana ? response.manzana : "";
              this.propiedad.plano = response.plano ? response.plano : "";
              this.propiedad.ubicacion = response.ubicacion
                ? response.ubicacion
                : "";
              this.propiedad.recordId = response.recordId
                ? response.recordId
                : "";
              this.propiedad.localidad = response.localidad
                ? response.localidad
                : "";

              this.rol_dir_encontrada = true;
              this.dialog.open(this.openModal);
              this.isopen = false;
            }
          }
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
          this.isopen = false;
        }
      );
  }

  cleanData() {
    this.propiedad = {
      rol: "",
      id_direcc: "",
      folio: "",
      calle: "",
      calle_num: 0,
      direccion_completa: "",
      direc_complemento: "",
      direc_compl_num: "",
      loteo: "",
      manzana: "",
      plano: "",
      ubicacion: "",
      recordId: "",
      localidad: "",
      json: {},
    };
    this.rol.reset();
    this.dir.reset();
    this.num.reset();
  }

  savePropiedad() {
    console.log("save propieda c");
    $("#dir_modal").modal("hide");
    this.actualRow = localStorage.getItem("informacionPropiedad");
    this.rows = JSON.parse(this.actualRow);
    if (this.rol_dir_encontrada) {
      this.rows.push({
        rol: this.propiedad.rol,
        id_direcc: this.propiedad.id_direcc,
        folio: this.propiedad.folio,
        calle: this.propiedad.calle,
        calle_num: this.propiedad.calle_num,
        direccion_completa: this.propiedad.direccion_completa,
        direc_complemento: this.propiedad.direc_complemento,
        direc_compl_num: this.propiedad.direc_compl_num,
        loteo: this.propiedad.loteo,
        manzana: this.propiedad.manzana,
        plano: this.propiedad.plano,
        ubicacion: this.propiedad.ubicacion,
        recordId: this.propiedad.recordId,
        localidad: this.propiedad.localidad,
        json: this.propiedad.json,
      });
    } else {
      this.rows.push({
        rol: this.propiedad.rol,
        id_direcc: this.propiedad.id_direcc,
        folio: this.propiedad.folio,
        calle: this.propiedad.calle,
        calle_num: this.propiedad.calle_num,
        direccion_completa:
          this.propiedad.calle + " Nº" + this.propiedad.calle_num,
        direc_complemento: this.propiedad.direc_complemento,
        direc_compl_num: this.propiedad.direc_compl_num,
        loteo: this.propiedad.loteo,
        manzana: this.propiedad.manzana,
        plano: this.propiedad.plano,
        ubicacion: this.propiedad.ubicacion,
        recordId: this.propiedad.recordId,
        localidad: this.propiedad.localidad,
        json: this.propiedad.json,
      });
    }
    localStorage.setItem("informacionPropiedad", JSON.stringify(this.rows));
    this.propiedad = {
      rol: "",
      id_direcc: "",
      folio: "",
      calle: "",
      calle_num: 0,
      direccion_completa: "",
      direc_complemento: "",
      direc_compl_num: "",
      loteo: "",
      manzana: "",
      plano: "",
      ubicacion: "",
      recordId: "",
      localidad: "",
      json: {},
    };
    this.rol.reset();
    this.dir.reset();
    this.num.reset();
    this.dialog.closeAll();
  }

  savePropiedadMulti(direccion) {
    console.log("save propieda c", direccion);
    $("#dir_modal2").modal("hide");
    this.actualRow = localStorage.getItem("informacionPropiedad");
    this.rows = JSON.parse(this.actualRow);
    this.rows.push({
      rol: direccion.rol ? direccion.rol : "",
      id_direcc: direccion.id_direcc ? direccion.id_direcc : "",
      folio: direccion.folio ? direccion.folio : "",
      calle: direccion.calle ? direccion.calle : "",
      calle_num: direccion.calle_num
        ? direccion.calle_num == 0
          ? ""
          : direccion.calle_num
        : "",
      direccion_completa: direccion.direccion_completa
        ? direccion.direccion_completa
        : "",
      direc_complemento: direccion.direc_complemento
        ? direccion.direc_complemento
        : "",
      direc_compl_num: direccion.direc_compl_num
        ? direccion.direc_compl_num
        : "",
      loteo: direccion.loteo ? direccion.loteo : "",
      manzana: direccion.manzana ? direccion.manzana : "",
      plano: direccion.plano ? direccion.plano : "",
      ubicacion: direccion.ubicacion ? direccion.ubicacion : "",
      recordId: direccion.recordId ? direccion.recordId : "",
      localidad: direccion.localidad ? direccion.localidad : "",
      json: direccion.json ? direccion.json : {},
    });
    localStorage.setItem("informacionPropiedad", JSON.stringify(this.rows));
    this.propiedad = {
      rol: "",
      id_direcc: "",
      folio: "",
      calle: "",
      calle_num: 0,
      direccion_completa: "",
      direc_complemento: "",
      direc_compl_num: "",
      loteo: "",
      manzana: "",
      plano: "",
      ubicacion: "",
      recordId: "",
      localidad: "",
      json: {},
    };
    this.rol.reset();
    this.dir.reset();
    this.num.reset();
    this.dialog.closeAll();
  }

  deletePropiedad(id, row) {
    let rowsAux = [];
    this.rows.map((data) => {
      if (data.rol != row.rol) {
        rowsAux.push(data);
      }
    });

    this.rows = rowsAux;
    localStorage.setItem("informacionPropiedad", JSON.stringify(this.rows));
    this.propiedad = {
      rol: "",
      id_direcc: "",
      folio: "",
      calle: "",
      calle_num: 0,
      direccion_completa: "",
      direc_complemento: "",
      direc_compl_num: "",
      loteo: "",
      manzana: "",
      plano: "",
      ubicacion: "",
      recordId: "",
      localidad: "",
      json: {},
    };
    this.rol.reset();
    this.dir.reset();
    this.num.reset();
    // for (let x = 0; x < this.rows.length; x++) {
    //     if (id == x) {
    //         this.rows.splice(x, 1);
    //         localStorage.setItem("informacionPropiedad", JSON.stringify(this.rows));
    //     }
    // }
  }

  traerCalles() {
    this._PropiedadService.traerCalles().subscribe(
      (data) => {
        this.options = data.calles;
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
